import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Portal access (empleados)
  const [portalToken, setPortalToken] = useState(() => localStorage.getItem('brokalia_portal'));
  const [portalOk, setPortalOk]       = useState(false);
  const [portalLoading, setPortalLoading] = useState(true);

  // Admin JWT
  const [adminToken, setAdminToken] = useState(() => localStorage.getItem('brokalia_admin'));
  const [adminUser, setAdminUser]   = useState(null);

  // Verificar token de portal al cargar
  useEffect(() => {
    if (portalToken) {
      // Verificamos que el token es válido contra el backend
      fetch('/api/auth/verify-portal', {
        headers: { Authorization: `Bearer ${portalToken}` }
      })
        .then(r => r.json())
        .then(d => { if (d.ok) setPortalOk(true); else clearPortal(); })
        .catch(clearPortal)
        .finally(() => setPortalLoading(false));
    } else {
      setPortalLoading(false);
    }
  }, []);

  // Verificar token de admin al cargar
  useEffect(() => {
    if (adminToken) {
      fetch('/api/auth/verify', { headers: { Authorization: `Bearer ${adminToken}` } })
        .then(r => r.json())
        .then(d => { if (d.ok) setAdminUser(d.username); else clearAdmin(); })
        .catch(clearAdmin);
    }
  }, []);

  const loginPortal = async (password) => {
    const res = await fetch('/api/auth/portal', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Contraseña incorrecta');
    localStorage.setItem('brokalia_portal', data.token);
    setPortalToken(data.token);
    setPortalOk(true);
  };

  const clearPortal = () => {
    localStorage.removeItem('brokalia_portal');
    setPortalToken(null);
    setPortalOk(false);
  };

  const loginAdmin = async (username, password) => {
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Credenciales incorrectas');
    localStorage.setItem('brokalia_admin', data.token);
    setAdminToken(data.token);
    setAdminUser(data.username);
  };

  const clearAdmin = () => {
    localStorage.removeItem('brokalia_admin');
    setAdminToken(null);
    setAdminUser(null);
  };

  const authFetch = (url, options = {}) =>
    fetch(url, { ...options, headers: { ...options.headers, Authorization: `Bearer ${adminToken}`, 'Content-Type': 'application/json' } });

  const authFetchForm = (url, options = {}) =>
    fetch(url, { ...options, headers: { ...options.headers, Authorization: `Bearer ${adminToken}` } });

  return (
    <AuthContext.Provider value={{
      portalOk, portalLoading, loginPortal, clearPortal,
      adminUser, loginAdmin, clearAdmin, authFetch, authFetchForm
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
